// extracted by mini-css-extract-plugin
module.exports = {"list":"SizesList_list__GMdr7","item":"SizesList_item__Z8i4s"};